require([
    'apps/course-intro/app'
], function (App) {
    "use strict";

    var app;

    function startApp(courseData) {
        app = new App();
        app.start(courseData);
    }

    $.ajax({
        "dataType": "json",

        // The course GUID has to be hard-coded as it's the topmost point in the
        // hierarchy of data and there's no config/API that returns it.
        "url": window.initData.appUrl + "/api:selfPacedCourse/course?id=458fd600-f36b-ff7c-eb2a-c14b0168a092",

        "xhrFields": {
            "withCredentials": true
        }
    }).done(function (courseData) {
        courseData.levels = courseData.children;

        delete courseData.childIds;
        delete courseData.children;

        startApp(courseData);
    });
});

define("apps/course-intro/main.js", function(){});

